import mAxios, {setToken} from './m-axios'
import {User} from './user'
import {REFRESH_TOKEN, TOKEN} from './constants'

export interface RegisterForm {
  phone: string
  captcha: string
}

export const Register = (form: RegisterForm) => {
  return mAxios({
    method: 'post',
    url: '/api/user',
    data: form,
  }).then(res => {
    if (res.data.code === 200) {
      sessionStorage.setItem(TOKEN, res.headers[TOKEN])
      sessionStorage.setItem(REFRESH_TOKEN, res.headers[REFRESH_TOKEN])
      setToken()
    }
    return res.data
  })
}

export interface UserInfoForm {
  password?: string
  user: User
  action: string
}

export const editUserInfo = (form: UserInfoForm) => {
  return mAxios({
    method: 'put',
    url: '/api/user',
    data: {
      password: form.password,
      action: form.action,
      ...form.user,
    },
  }).then(res => res.data)
}
